const Profession = Object.freeze({
  ED: 'ED',
  CA: 'CA',
  BL: 'BL',
  EN: 'EN',
  EM: 'EM',
  BF: 'BF',
  HM: 'HM',
  LO: 'LO',
  PG: 'PG',
  JO: 'JO',
  RE: 'RE',
  HO: 'HO',
  SM: 'SM',
  SR: 'SR',
  SS: 'SS',
  SP: 'SP',
  ST: 'ST',
  TE: 'TE',
  FF: 'FF',
  OA: 'OA',
  MA: 'MA',
  UN: 'UN',
  CO: 'CO',
  PH: 'PH',
  HE: 'HE',
  TR: 'TR'
})
export default Profession
export type ProfessionStrings = typeof Profession[keyof typeof Profession]
// RESERVE BELOW
